import axios from 'axios';
import API_BASE_URL from '../config.js';


export const ExistingEventServices = async (token, userData) => {
    try {
        if (!token) {
            throw new Error('No token available');
        }

        const response = await axios.get(`${API_BASE_URL}api/exits-user-event/`, {
            params: {
                user_id: userData.user_id,
                event_id: userData.event_id
            },
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
}

const EventServices = async (token) => {
    try {
        if (!token) {
            throw new Error('No token available');
        }

        const response = await axios.get(`${API_BASE_URL}api/events/`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        throw new Error(error);
    }
}


export const EventServicesById = async (token, idEvents) => {
    try {
        if (!token) {
            throw new Error('No token available');
        }

        const response = await axios.get(`${API_BASE_URL}api/events/${idEvents}/`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        throw new Error(error);
    }
}

export default EventServices;